import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Bookmark as BookmarkIcon, X } from "lucide-react";

export default function Bookmarks() {
  const [items, setItems] = useState([]);

  const load = () => {
    api.get("/bookmarks").then((r) => setItems(r.data)).catch(() => {});
  };
  useEffect(load, []);

  const remove = async (b) => {
    try {
      await api.delete("/bookmarks", { data: { module_id: b.module_id, chapter_id: b.chapter_id } });
      setItems((x) => x.filter((y) => !(y.module_id === b.module_id && y.chapter_id === b.chapter_id)));
      toast.success("Removed");
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <div className="max-w-4xl mx-auto px-6 py-14">
      <div className="font-mono text-xs uppercase tracking-[0.2em] text-[#525252] mb-3">Your bookmarks</div>
      <h1 className="font-serif text-5xl font-black text-[#0A0A0A] tracking-tight mb-10">Saved for later.</h1>

      {items.length === 0 ? (
        <div className="border border-[#E5E5E0] p-10 text-center">
          <BookmarkIcon className="w-8 h-8 text-[#C5A059] mx-auto mb-3" strokeWidth={1.5} />
          <p className="text-[#525252] mb-4">You have not bookmarked anything yet.</p>
          <Link to="/modules" data-testid="bookmarks-browse" className="inline-block px-5 py-2.5 bg-[#0A0A0A] text-[#FFFFFF] hover:bg-[#000000] transition-colors text-sm">
            Browse modules
          </Link>
        </div>
      ) : (
        <div className="border-t border-[#E5E5E0]" data-testid="bookmarks-list">
          {items.map((b) => (
            <div
              key={`${b.module_id}-${b.chapter_id}`}
              data-testid={`bookmark-item-${b.chapter_id}`}
              className="flex items-center gap-4 py-5 border-b border-[#E5E5E0]"
            >
              <div className="font-mono text-sm text-[#C5A059] w-16">{b.chapter_number}</div>
              <div className="flex-1">
                <Link to={`/modules/${b.module_id}/chapters/${b.chapter_id}`} className="font-serif text-lg font-semibold text-[#0A0A0A] hover:text-[#000000]">
                  {b.chapter_title}
                </Link>
                <div className="text-xs font-mono uppercase tracking-wider text-[#525252] mt-1">{b.module_title}</div>
              </div>
              <button
                data-testid={`bookmark-remove-${b.chapter_id}`}
                onClick={() => remove(b)}
                className="p-2 text-[#525252] hover:text-[#0A0A0A] transition-colors"
                aria-label="Remove bookmark"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
